<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }" :class="className">
    <b-input-group>
      <b-form-input
        type="text"
        placeholder="dd.mm.yyyy"
        autocomplete="off"
        :value="getField"
        @input="updateField"
      ></b-form-input>
      <b-form-datepicker
        :type="type"
        :state="onValidateField(valid, errors, changed)"
        :placeholder="placeholder"
        :label="field"
        locale="de"
        v-bind="labels['de'] || {}"
        button-only
        start-weekday="1"
        right
        @context="onContext"
        :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
      ></b-form-datepicker>
      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
    </b-input-group>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      labels: {
        de: {
          labelPrevDecade: 'Vorheriges Jahrzehnt',
          labelPrevYear: 'Vorheriges Jahr',
          labelPrevMonth: 'Vorheriger Monat',
          labelCurrentMonth: 'Aktueller Monat',
          labelNextMonth: 'Nächster Monat',
          labelNextYear: 'Nächstes Jahr',
          labelNextDecade: 'Nächstes Jahrzehnt',
          labelToday: 'Heute',
          labelSelected: 'Ausgewähltes Datum',
          labelNoDateSelected: 'Kein Datum gewählt',
          labelCalendar: 'Kalender',
          labelNav: 'Kalendernavigation',
          labelHelp: 'Mit den Pfeiltasten durch den Kalender navigieren'
        }
      }
    }),
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      field: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      placeholder: String,
      className: String,
      rules: String,
      appendText: String
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.calculator.formData[tab][field]
      }
    }),
    methods: {
      updateField (value) {
        const { tab, field } = this
        this.$store.commit('calculator/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      onContext (ctx) {
        this.updateField(ctx.activeFormatted)
      }
    }
  }
</script>
